import { Common, color } from '@stockbit/ui';
import If from 'global/ErrorHandlers/If';

import Image from 'global/Image';
import { EmittenInfoResponse } from 'global/Securities/types/api/emittenInfo';
import { CompanyLabelContainer, LabelWrapper, LabelDayTrade } from './styled';

const { Text, Flex } = Common;

interface iCompanylabel {
  notation: EmittenInfoResponse['notation'];
  corpAction: EmittenInfoResponse['corp_action'];
  indexes: EmittenInfoResponse['indexes'];
  tradeType: EmittenInfoResponse['trade_type'];
  dayTradeInfo: EmittenInfoResponse['day_trade_info'];
}

export const CompanyLabel = ({
  notation,
  corpAction,
  indexes,
  tradeType,
  dayTradeInfo,
}: iCompanylabel) => {
  const syariah = indexes.indexOf('JII') > -1 || indexes.indexOf('ISSI') > -1;
  const isAccel = tradeType === 'ACCEL';
  const isDbx = indexes.indexOf('DBX') > -1;
  const isDayTrade = dayTradeInfo?.is_show_multiplier;

  return (
    <CompanyLabelContainer
      align="center"
      justify="center"
      data-cy="trade-detail-modal-company-label=container"
    >
      {notation.length !== 0 && (
        <Flex>
          <Image src="/icon/ic_indicator.svg" alt="warning" width="12px" />
        </Flex>
      )}
      {corpAction.active && (
        <Flex>
          <Image src="/icon/corp_action_event_icon.svg" alt="corp_action" />
        </Flex>
      )}
      <If condition={isDayTrade}>
        <LabelDayTrade>
          <Image
            src="/images/day-trade/lightning-filled-company.svg"
            alt=""
            height="14"
            width="14"
          />
          <Text size="12px" color="#8277f8" family="bold">
            {dayTradeInfo.multiplier}x
          </Text>
        </LabelDayTrade>
      </If>
      <If condition={isAccel}>
        <LabelWrapper>
          <Text size="12px" color={color.primary}>
            Akselerasi
          </Text>
        </LabelWrapper>
      </If>
      <If condition={isDbx}>
        <LabelWrapper>
          <Text size="12px" color={color.primary}>
            DBX
          </Text>
        </LabelWrapper>
      </If>
      <If condition={syariah}>
        <LabelWrapper>
          <Text size="12px" color={color.primary}>
            Syariah
          </Text>
        </LabelWrapper>
      </If>
    </CompanyLabelContainer>
  );
};

export default CompanyLabel;
